import MigrationsPanel from "../components/MigrationsPanel";
import StateDiagnostics from "../components/StateDiagnostics";

export default function AdminMigrations() {
  return (
    <div className="min-h-screen" data-testid="admin-migrations-page">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-4 sm:py-6 space-y-5">
        <StateDiagnostics />
        <MigrationsPanel />
      </div>
    </div>
  );
}
